import { Tooltip } from '@mui/material';
import React from 'react';
import { IoMdAdd, IoMdRefresh } from 'react-icons/io';

interface AddAndRefreshConsultancyOptionsProps {
  fetchVendors: () => void;
}

const AddAndRefreshConsultancyOptions = function AddAndRefreshConsultancyOptions(
  props: AddAndRefreshConsultancyOptionsProps,
) {
  const { fetchVendors } = props;

  const accountsUrl = process.env.REACT_APP_AUTH_DOMAIN;

  return (
    <>
      <Tooltip title="Refresh Consultancies.">
        <button
          type="button"
          onClick={(e) => {
            e.preventDefault();
            fetchVendors();
          }}
          className="ml-2 border-primary rounded-full cursor-pointer mt-[5px]"
        >
          <IoMdRefresh size={20} className="text-primary" />
        </button>
      </Tooltip>
      <Tooltip title="Not found? Click here to add new Consultancy.">
        <button
          type="button"
          className="ml-2 border-primary rounded-full cursor-pointer mt-[5px]"
          onClick={(e) => {
            e.preventDefault();
            window.open(`${accountsUrl}/vendors`, '_blank');
          }}
        >
          <IoMdAdd size={20} className="text-primary" />
        </button>
      </Tooltip>
    </>
  );
};

AddAndRefreshConsultancyOptions.defaultProps = {

};

AddAndRefreshConsultancyOptions.propTypes = {

};

export default AddAndRefreshConsultancyOptions;
